module.exports = __webpack_public_path__ + "img/icon-medicine.b853740d.svg";